// import { useTranslation } from "react-i18next";

// import hooks
import { useState, useEffect } from "react";
import useWindowSize from "../../utils/custom-hooks/useWindowSize";
import { useTranslation } from "react-i18next";

//assets
import logo from "../../assets/img/ocean.png";

// components
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Container } from "react-bootstrap";
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';
import TopHeader from "./TopHeader";
import CurrencyDropdown from "./CurrencyDropdown";
import LgList from "./LgList";
import List from "./List";
import SearchForm from "./SearchForm";
import LoginModal from "./LoginModal";
import VerifyModal from "./VerifyModal";
import SignupModal from "./SignupModal";

const Nav = ({ changeLang, changeColorMode, lang, view, mode }) => {
    const [offset, setOffset] = useState(0);
    const [navClass, setNavClass] = useState("nav");
    const [loginModalShow, setLoginModalShow] = useState(false);
    const [verifyModalShow, setVerifyModalShow] = useState(false);
    const [signupModalShow, setSignupModalShow] = useState(false);

    const [t] = useTranslation("global");
    const windowWidth = useWindowSize();

    const showVerifyHideLogin = () => {
        setLoginModalShow(false);
        setVerifyModalShow(true);
    };
    const showVerifyHideSignup = () => {
        setSignupModalShow(false);
        setVerifyModalShow(true);
    };
    const showSignupHideLogin = () => {
        setLoginModalShow(false);
        setSignupModalShow(true);
    };
    const showLoginHideSignup = () => {
        setSignupModalShow(false);
        setLoginModalShow(true);
    };

    useEffect(() => {
        const className = `nav ${offset > 200 ? "sticky" : ""}`;
        setNavClass(className);
    }, [offset]);

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener("scroll", onScroll);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <>
            <LoginModal
                show={loginModalShow}
                onHide={() => setLoginModalShow(false)}
                backdrop="static"
                keyboard={false}
                lang={lang}
                view={view}
                mode={{
                    mode,
                    cls: setLoginModalShow,
                    openVerify: showVerifyHideLogin,
                    openSignup: showSignupHideLogin
                }}
                // cls={}
                // openVerify={}
            />
            <SignupModal
                show={signupModalShow}
                onHide={() => setSignupModalShow(false)}
                backdrop="static"
                keyboard={false}
                lang={lang}
                view={view}
                mode={{
                    mode,
                    cls: setSignupModalShow,
                    openVerify: showVerifyHideSignup,
                    openLogin: showLoginHideSignup
                }}
                // cls={}
                // openVerify={}
            />
            <VerifyModal
                show={verifyModalShow}
                onHide={() => setVerifyModalShow(false)}
                backdrop="static"
                keyboard={false}
                lang={lang}
                view={view}
                mode={{ mode, cls: setVerifyModalShow }}
                // openVerify={showVerifyHideLogin}
            />
            <div className={navClass}>
                <TopHeader />
                {/* <Container> */}
                {windowWidth < 992 && (
                    <Row className="currency-dropdown-row">
                        <CurrencyDropdown
                            changeLang={changeLang}
                            changeColorMode={changeColorMode}
                        />
                    </Row>
                )}

                <Container>
                    <Row className="top-nav-row">
                        {windowWidth < 992 && <List />}
                        <Col lg={{ order: "first" }}>
                            <img className="nav-logo" src={logo} alt="logo" />
                            {windowWidth >= 992 && <SearchForm />}
                            {windowWidth >= 992 && <LgList />}
                        </Col>
                        {/* {windowWidth >= 992 && <Col />} */}
                        <Col className="nav-login-row">
                            <div
                                className="login-btn nav-btn"
                                onClick={() => setLoginModalShow(true)}
                            >
                                <div className="login-svg"></div>
                                <p>{t("nav.login")}</p>
                            </div>

                            <div className="cart-btn nav-btn">
                                <div className="top-cart-svg">
                                    <div className="cart-svg"></div>
                                    <span>1</span>
                                </div>
                                <p>{t("nav.cart")}</p>
                            </div>

                            {windowWidth >= 992 && (
                                <CurrencyDropdown
                                    changeLang={changeLang}
                                    changeColorMode={changeColorMode}
                                />
                            )}
                        </Col>
                    </Row>
                </Container>
                {/* </Container> */}
            </div>
        </>
    );
};

export default Nav;
